<template lang="pug">
  div
    table.table.table-striped.table-bordered
      tr
        td 1. Говорил ли Вам врач когда-либо, что у Вас имеется:
        td
      tr
        td 1.1 гипертоническая болезнь, повышенное артериальное давление (артериальная гипертония)?
        td {{formatAnswer(data.body.content.is_hypertension, 1)}}
      tr
        td Если «Да», то принимаете ли Вы препараты для снижения давления?
        td {{formatAnswer(data.body.content.is_hypertension_drug, 1)}}
      tr
        td 1.2 сахарный диабет или повышенный уровень глюкозы (сахара) в крови?
        td {{formatAnswer(data.body.content.is_diabetes, 1)}}
      tr
        td Если «Да», то принимаете ли Вы препараты для снижения уровня сахара?
        td {{formatAnswer(data.body.content.is_diabetes_drug, 1)}}
      tr
        td 1.3 злокачественное новообразование?
        td {{formatAnswer(data.body.content.is_malignant_neoplasm, 1)}}
      tr
        td Если «Да», то какое?
        td {{formatAnswer(data.body.content.malignant_neoplasm, 2)}}
      tr
        td 1.4 повышенный уровень холестерина?
        td {{formatAnswer(data.body.content.is_elevated_cholesterol, 1)}}
      tr
        td Если «Да», то принимаете ли Вы препараты для снижения уровня холестерина?
        td {{formatAnswer(data.body.content.is_elevated_cholesterol_drug, 1)}}
      tr
        td 1.5 перенесенный инфаркт миокарда?
        td {{formatAnswer(data.body.content.is_myocardial_infarction, 1)}}
      tr
        td 1.6 перенесенный инсульт?
        td {{formatAnswer(data.body.content.is_stroke, 1)}}

      tr
        td 1.7 хронический бронхит или бронхиальная астма?
        td {{formatAnswer(data.body.content.is_bronchitis, 1)}}
      tr
        td 2. Возникает ли у Вас, когда поднимаетесь по лестнице, идете в гору или спешите, или при выходе из теплого помещения на холодный воздух, боль или ощущение давления, жжения, тяжести или явного дискомфорта за грудиной и (или) в левой половине грудной клетки, и (или) в левом плече, и (или) в левой руке?
        td {{formatAnswer(data.body.content.is_stress_pain, 1)}}
      tr
        td 3. Если на вопрос 2 ответ «Да», то указанные боли/ощущения/дискомфорт исчезают в течение не более чем 20 мин после прекращения ходьбы/адаптации к холоду/в тепле/в покое и (или) они исчезают через 1-5 мин после приема нитроглицерина
        td {{formatAnswer(data.body.content.stress_pain_passes, 3)}}
      tr
        td 4. Возникала ли у Вас резкая слабость в одной руке и/или ноге так, что Вы не могли взять или удержать предмет, встать со стула, пройтись по комнате?
        td {{formatAnswer(data.body.content.is_limb_weakness, 1)}}
      tr
        td 5. Возникало ли у Вас внезапное без понятных причин кратковременное онемение в одной руке, ноге или половине лица, губы или языка?
        td {{formatAnswer(data.body.content.is_short_numbness, 1)}}
      tr
        td 6. Возникала ли у Вас когда-либо внезапно кратковременная потеря зрения на один глаз?
        td {{formatAnswer(data.body.content.is_short_vision_loss, 1)}}
      tr
        td 7. Бывают ли у Вас отеки на ногах к концу дня?
        td {{formatAnswer(data.body.content.is_legs_edema, 1)}}
      tr
        td 8. Бывают ли у Вас ежегодно периоды ежедневного кашля с отделением мокроты на протяжении примерно 3-х месяцев в году?
        td {{formatAnswer(data.body.content.is_recurrent_cough, 1)}}
      tr
        td 9. Бывают ли у Вас свистящие или жужжащие хрипы в грудной клетке при дыхании, не проходящие при откашливании?
        td {{formatAnswer(data.body.content.is_wheezing, 1)}}
      tr
        td 10. Бывало ли у Вас когда-либо кровохарканье?
        td {{formatAnswer(data.body.content.is_hemoptysis, 1)}}
      tr
        td 11. Беспокоят ли Вас боли в области верхней части живота (в области желудка), отрыжка, тошнота, рвота, ухудшение или отсутствие аппетита?
        td {{formatAnswer(data.body.content.is_stomachache, 1)}}
      tr
        td 12. Бывают ли у Вас кровяные выделения с калом?
        td {{formatAnswer(data.body.content.is_bloody_feces, 1)}}
      tr
        td 13. Курите ли Вы? (курение одной и более сигарет в день)
        td {{formatAnswer(data.body.content.is_smoking, 1)}}
      tr
        td 14. Были ли у Вас переломы при падении с высоты своего роста, при ходьбе по ровной поверхности или перелом без видимой причины, в т.ч. перелом позвонка?
        td {{formatAnswer(data.body.content.is_fracture, 1)}}
      tr
        td 15. Считаете ли Вы, что Ваш рост заметно снизился за последние годы?
        td {{formatAnswer(data.body.content.is_decreased_growth, 1)}}
      tr
        td 16. Присутствует ли в Вашем ежедневном рационе 400-500 г сырых овощей и фруктов?
        td {{formatAnswer(data.body.content.is_plants_portion, 1)}}
      tr
        td 17. Употребляете ли Вы белковую пищу (мясо, рыбу, бобовые, молочные продукты) 3 раза или более в неделю?
        td {{formatAnswer(data.body.content.is_protein_food, 1)}}
      tr
        td 18. Тратите ли Вы ежедневно на ходьбу, утреннюю гимнастику и другие физические упражнения 30 минут и более?
        td {{formatAnswer(data.body.content.is_physical_exercises, 1)}}
      tr
        td 19. Были ли у Вас случаи падений за последний год?
        td {{formatAnswer(data.body.content.is_last_year_fall, 1)}}
      tr
        td 20. Испытываете ли Вы существенные ограничения в повседневной жизни из-за снижения зрения?
        td {{formatAnswer(data.body.content.is_vision_loss_limitation, 1)}}
      tr
        td 21. Испытываете ли Вы существенные ограничения в повседневной жизни из-за снижения слуха?
        td {{formatAnswer(data.body.content.is_hearing_loss_limitation, 1)}}
      tr
        td 22. Чувствуете ли Вы себя подавленным, грустным или встревоженным в последнее время?
        td {{formatAnswer(data.body.content.is_oppression, 1)}}
      tr
        td 23. Страдаете ли Вы недержанием мочи?
        td {{formatAnswer(data.body.content.is_incontinence, 1)}}
      tr
        td 24. Испытываете ли Вы затруднения при перемещении по дому, улице (ходьба на 100м), подъем на 1 лестничный пролет?
        td {{formatAnswer(data.body.content.is_movement_obstruction, 1)}}
      tr
        td 25. Есть ли у Вас проблемы с памятью, пониманием, ориентацией или способностью планировать?
        td {{formatAnswer(data.body.content.is_mental_weakness, 1)}}
      tr
        td 26. Считаете ли Вы, что заметно похудели за последнее время (не менее 5 кг за полгода)?
        td {{formatAnswer(data.body.content.is_weight_loss, 1)}}
      tr
        td 27. Если Вы похудели, считаете ли Вы, что это связано со специальным соблюдением диеты или увеличением физической активности?
        td {{formatAnswer(data.body.content.is_weight_loss_reasonably, 1)}}
      tr
        td 28. Если Вы похудели, считаете ли Вы, что это связано со снижением аппетита?
        td {{formatAnswer(data.body.content.is_weight_loss_appetite, 1)}}
      tr
        td 29. Сколько лекарственных препаратов Вы принимаете ежедневно или несколько раз в неделю?
        td {{formatAnswer(data.body.content.drug_number, 2)}}
      tr
        td 30. Есть ли у Вас другие жалобы на свое здоровье, не вошедшие в настоящую анкету и которые Вы бы хотели сообщить врачу (фельдшеру)
        td {{formatAnswer(data.body.content.is_other_complaints, 1)}}
</template>
<script>
export default {
  props: ['data'],

  methods: {
    formatAnswer (fact, type) {
      switch (type) {
        case 1:
          return fact !== undefined ? (fact ? 'Да' : 'Нет') : '—'
        case 2:
          return fact || '—'
        case 3:
          return fact ? fact.name : '—'
      }
    }
  }
}
</script>
<style lang="sass" scoped>
@import "@/css/DocumentStyles.sass"
</style>
